import styled from "styled-components";

export const StyledMain = styled.main`
	/* min-height: 100%;
	flex-grow: 1;
	display: flex;
	flex-direction: column; */
	padding-bottom: 5rem;
`;
